export default __webpack_public_path__ + "3423511e7527ab632ecc844cef264f5e.jpg";